module.exports = __webpack_public_path__ + "static/media/dlocal.1ee35905.png";